import type {ReactNode, KeyboardEvent} from 'react'
import {useNavigate} from 'react-router-dom'
import {Card} from '@/components/ui/card'
import {cn} from '@/lib/utils'

interface ClickableCardProps {
    to: string
    children: ReactNode
    className?: string
    'data-testid'?: string
    'aria-labelledby'?: string
    'aria-describedby'?: string
}

export function ClickableCard({
    to,
    children,
    className,
    'data-testid': dataTestId,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
}: ClickableCardProps) {
    const navigate = useNavigate()

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            navigate(to)
        }
    }

    return (
        <Card
            role="link"
            tabIndex={0}
            className={cn('hover:bg-muted/50 transition-colors cursor-pointer h-full', className)}
            onClick={() => navigate(to)}
            onKeyDown={handleKeyDown}
            data-testid={dataTestId}
            aria-labelledby={ariaLabelledBy}
            aria-describedby={ariaDescribedBy}
        >
            {children}
        </Card>
    )
}
